<template>
  <Input :classes="classes" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import Input from '@/components/Input'

export default {
  components: {
    Input,
  },
  computed: {
    classes () {
      return {
        root: this.rootClass,
        input: this.inputClass,
      }
    },
    rootClass () {
      return [this.$style.root]
    },
    inputClass () {
      return [this.$style.input]
    },
  },
}
</script>

<style lang="scss" module>
.root {
}

.input {
  font-size: 1rem;
  @apply py-2;
  @apply px-2;
}
</style>
